module.exports = __webpack_public_path__ + "static/media/8_IMAGE_5-SPIRULINA-desktop.4b718445.jpg";